import { http } from 'services/http';
import { TRIP_TASKS_GET_MANY } from 'api/query-keys';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useDeleteCargoFromTripTask = (tripId: number, tripTaskId: number) => {
  return useMutationBase<unknown, unknown, number[]>({
    mutationFn: async (cargoTripIds) => {
      await http.delete<unknown>(`/v1/trips/${tripId}/trip-tasks/${tripTaskId}/cargo-trips`, {
        data: { cargoTripIds },
      });
    },
    invalidateCallback: () => [[TRIP_TASKS_GET_MANY, tripId]],
  });
};
